import { render } from "./delivery-date-type-detail.vue?vue&type=template&id=05f4e1aa"
import script from "./delivery-date-type-detail.vue?vue&type=script&lang=js"
export * from "./delivery-date-type-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__